/**分享**/
<template>
  <div id="share-qrcode">
    <div class="QrCode">
      <img src="/static/img/qr_bg.png" alt="">
    </div>
    <div class="bottom">
      <div class="bottom-code">
        <xk-qr-code :val="url"></xk-qr-code>
      </div>
      <span>扫码分享，即刻下单</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkQrCode from '../module/qrCode/src/qrCode'

  export default {
    name: 'qrCode',
    components: {XkQrCode},
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      })
    },
    data () {
      return {
        url: ''
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.$store.dispatch('queryQrCode', {
            company_id: that.loginData.passenger.company_id,
            id: that.loginData.passenger.id,
            fn (data) {
              if (data && data.code === 1) {
                that.url = data.url
              }
            }
          })
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  #share-qrcode {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: #fff;
    padding-top: 69px;
    .QrCode {
      width: 100%;
      height: 180px;
      background-size: cover;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      img {
        height: 100%;
        border-radius: 0.333rem;
      }
    }
    .bottom{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 41px;
      .bottom-code{
        width: 140px;
        height: 140px;
        padding: 10px;
        box-sizing: border-box;
        border: 1px #D6D6D6 solid;
      }
      span{
        margin-top: 21px;
        font-size:14px;
        font-weight:400;
        color:rgba(34,34,34,1);
        line-height:20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// qrCode.vue?71f99eaf